import {
  EmployeeProfessional,
  EmployeeProfessionalFormValues,
} from '@/core/domain/enterprise/Employees/Employees.types';

type Callback = (values: EmployeeProfessional) => Promise<unknown>;

export default async function handlerPersonalValues(
  values: EmployeeProfessionalFormValues,
  callback: Callback,
) {
  let obj: EmployeeProfessional = {
    ...values,
    admissionDate: values.admissionDate
      ? values.admissionDate.toDate()
      : undefined,
    salary: values?.salary || 0,
    partCommission: values?.partCommission || 0,
    serviceCommission: values?.serviceCommission || 0,
  };

  if (values.functionId) {
    obj = { ...obj, function: { id: values.functionId } };
  }

  await callback(obj);
}
